import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSend: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="send, email, paper-plane, arrow"><path d="M21.2086 3.74568C21.3027 3.47422 21.2335 3.17285 21.0303 2.96969C20.8272 2.76653 20.5258 2.69729 20.2543 2.79139L1.50434 9.29139C1.19983 9.39696 0.996802 9.68527 1.00004 10.0076C1.00327 10.3298 1.21205 10.614 1.51862 10.7134L10.4046 13.5954L13.2866 22.4814C13.386 22.788 13.6702 22.9967 13.9925 23C14.3147 23.0032 14.6031 22.8002 14.7086 22.4957L21.2086 3.74568Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSend;
